import { Injectable } from "@angular/core";
import { JsonHttpService } from "../http/json-http.service";
import { CurrentUserService } from '../../user/services/current-user.service';
import { EMPTY } from "rxjs";
import { AuditLogEntry } from "./models/audit-log-entry";
import { UserLogout } from "../../user/models/user-logout";

/**
 * Logging service which can log entries in the backend-logging framework.
 */
@Injectable({
    providedIn: 'root'
})
export class AuditLoggingService {

    constructor(private httpService: JsonHttpService, private currentUserService: CurrentUserService) {
    }

    public logUserLogout(triggeredByUser: boolean): Promise<void> {
        return this.logEntry("User access", "User logout", { TriggerdByUser: true });
    }

    public startObserverSubsriptions(): void {
        this.currentUserService.userLoggedOutObserverSubject.subscribe(async (userLogout) => {
            await this.logUserLogout(userLogout.triggeredByUser);
        });
    }

    private logEntry(area: string, action: string, logObject: object): Promise<void> {
        // Extra check to prevent calling the backend without a user being logged in...
        const isLoggedIn = this.currentUserService.hasCurrentUser();
        if (isLoggedIn) {
            let logEntry = new AuditLogEntry();
            logEntry.Action = action;
            logEntry.Area = area;
            logEntry.LogObject = logObject;

            return this.httpService.post('/api/auditlog/log-entry', logEntry, null, false).toPromise().then(() => { }).catch(() => { });
        }
        else {
            return EMPTY.toPromise();
        }
    }
}
